.root {
    width: 100%;
}

.title {
    color: var(--mantine-color-white);
    font-size: 1.125rem;
    font-weight: 700;
}

.segmented {
    background: var(--mantine-color-dark-7);
    border: 1px solid var(--mantine-color-dark-4);
}

.segmentedLabel {
    color: var(--mantine-color-dark-1);
    font-size: 0.8125rem;
    font-weight: 500;
}

.segmentLabel {
    display: inline-flex;
    align-items: center;
    gap: 0.375rem;
    color: var(--mantine-color-white);
}

.segmentLabelDisabled {
    color: var(--mantine-color-dark-2);
}

.lastUpdated {
    color: var(--mantine-color-dark-1);
}

.lastUpdatedText {
    color: var(--mantine-color-dark-1);
    font-size: 0.8125rem;
}
